import { useSession } from '@ferreri/minato-auth-react';
import { useEffect, useMemo, useState } from 'react';

export const useReconciliation = () => {
  const [isLoading, setIsLoading] = useState(true);
  const { data: session, isLoading: isLoadingSession } = useSession();
  const [doesNeedReconciliation, setDoesNeedReconciliation] = useState(false);

  const hasAccount = useMemo(() => {
    return Boolean(session?.identity?.metadata_public?.account_id);
  }, [session]);

  useEffect(() => {
    if (!isLoadingSession) {
      const hasAppleLogin = session?.authentication_methods?.some(
        (authentication) => authentication.provider === 'apple',
      );
      const isPrivateEmail = session?.identity?.traits?.email?.includes(
        'privaterelay.appleid',
      );

      if (!hasAccount && hasAppleLogin && isPrivateEmail) {
        setDoesNeedReconciliation(true);
      }

      setIsLoading(false);
    }
  }, [isLoadingSession, session, hasAccount]);

  return {
    isLoading,
    doesNeedReconciliation,
    hasAccount,
    hasSession: Boolean(session),
  };
};
